module.exports = __webpack_public_path__ + "media/frontend/svg/information2-9b4626a6926457b21e755a53d1acaccb.svg";